import {REST_METHODS} from '@/src/app/constants/api';
import unauthorizedFetch from '@/src/app/utils/unauthorizedFetch';

export const fetchThemeMode = () => {
  // @ts-ignore
  return unauthorizedFetch({
    method: REST_METHODS.GET,
    path: `/api/v1/setting`,
  });
};
